import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "../Navbar/Navbaranim";
import Jumbotron from "./Jumbotron/Jumbo";
import JumbotronMobile from "./JumbotronMobile/JumbotronMobile";
import WebsiteTest from "./VulReport/VulSection";
import Display from "./Display/Display";
import Security from "./Security/Security";
import Services from "./Services/Services";
import LatestNews from "./LatestNews/LatestNews";
import Blog from "./Blog/Blog";
import Contactus from "../ContactUs/Contactus";
import Footer from "../Footer/Footer";
import "./Homepage.css";
import Blog2 from "./Blog2/Blog";
import { Dimensions } from "../Helper/sitedimension";
import BlogMobile from "./BlogMobile/BlogMobile";

const Homepage = () => {
  const { width } = Dimensions.useWindowDimensions();
  return (
    <div className="Homepage">
      <Navbar className="navbar" />
      {width > 500 ? (
        <Jumbotron className="jumbotron" />
      ) : (
        <JumbotronMobile className="jumbotronmobile" />
      )}
      <WebsiteTest className="cch" />
      <Display className="display" />
      <Security className="security" />
      <Services className="services" />
      {width > 500 ? <LatestNews className="latestnews" /> : null}
      {width > 500 ? <Blog className="blog" /> : <BlogMobile />}
      {width > 500 ? (
        <Contactus className="contactus" />
      ) : (
        <Contactus className="conmobile" />
      )}
      <Footer className="footer" />
    </div>
  );
};

export default Homepage;
